import { document, Document, Identifiable } from "@planzone/dto";

function getEmptyDocuments(): Identifiable<Document>[] {
  return [
    {
      ...document,
      name: "empty",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      uuid: "1",
    },
    {
      ...document,
      name: "empty",
      mimeType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      uuid: "2",
    },
    {
      ...document,
      name: "empty",
      mimeType:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      uuid: "3",
    },
  ];
}

export { getEmptyDocuments };
